<template>
  <vxe-modal v-model="visible" :destroyOnClose="true" :loading="loading" :title="$t('menu.systemParameterSetting')" show-footer size="mini" type="confirm" width="40%" @cancel="cancel" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="labelCol" :model="data" :rules="rules" :wrapper-col="wrapperCol">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.parameterName')" prop="name">
            <a-input v-model="data.name"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.customized')" prop="customized">
            <vxe-switch v-model="data.customized"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.parameterValue')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" prop="value">
            <a-input v-model="data.value" :autosize="{ minRows: 15 }" type="textarea"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.enterprise')" prop="enterprise">
            <a-select v-model="data.enterprise.id" :options="enterprises" allowClear @change="onEnterpriseChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.warehouse')" prop="warehouse">
            <a-select v-model="data.warehouse.id" :options="warehouses" allowClear @change="onWarehouseChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.parameterNote')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" prop="notes">
            <a-input v-model="data.notes" type="textarea"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { findAll, findOne, save } from '@/api/Api'
import { Parameter } from '@/api/dto/admin/Parameter'
import { Enterprise } from '@/api/dto/common/Enterprise'
import { Warehouse } from '@/api/dto/common/Warehouse'

export default {
  name: 'ParameterEditor',
  data() {
    return {
      visible: false,
      loading: false,
      data: new Parameter(),
      enterprises: [],
      warehouses: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      rules: {
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        value: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  created() {
    Promise.all([
      findAll('enterpriseFactory', { available: true }).then(res => {
        if (res.success) {
          this.enterprises = res.result.map(item => {
            return { label: item.name, value: item.id }
          })
        }
      }),
      findAll('warehouseFactory', { available: true }).then(res => {
        if (res.success) {
          this.warehouses = res.result.map(item => {
            return { label: item.name, value: item.id }
          })
        }
      })
    ])
  },
  methods: {
    onEnterpriseChange(value) {
      this.data.enterprise = new Enterprise({ id: value })
    },
    onWarehouseChange(value) {
      if (!value) this.onEnterpriseChange()
      this.data.warehouse = new Warehouse({ id: value })
    },
    add() {
      this.visible = true
      this.data = new Parameter()
      this.data.available = true
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('parameterFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.data = new Parameter(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const data = this.data.toJSONObject()
      save('parameterPersister', data).then(res => {
        if (res.success) {
          this.data = new Parameter(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.cancel()
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) this.save()
      })
    },
    cancel() {
      this.visible = false
    }
  }
}
</script>